import React, { lazy } from 'react';
import { Trans } from '@lingui/macro';

const OrganizationChartPage = lazy(() =>
  import('./pages/chart').then(module => ({
    default: module.OrganizationChartPage,
  })),
);

export const routes = [
  {
    path: '/hr/organization',
    component: OrganizationChartPage,
    exact: true,
    navigation: {
      name: <Trans>Organization Chart</Trans>,
      shortName: 'OC',
    },
  },
];
